import { memo } from "react";

const PropertyTags = ({category, newToHubzuFlag, isNewToHubzu, sellerId, fcOnlineFlag, isRecommendedProperties=false, cwcotUpdatesEnabled, cwcotUpdatesValid }) => {
  const label = {
    REO: sellerId === '501' ? '' : 'BANK-OWNED',
    SC: sellerId === '501' ? '' : cwcotUpdatesEnabled && cwcotUpdatesValid ? 'CWCOT FIRST LOOK PROGRAM' : 'CWCOT-SECOND CHANCE',
    NPL: sellerId === '501' ? '' : 'NON-PERFORMING LOAN',
    SHRT_SALE: 'SHORT-SALE',
    NON_REO: sellerId === '501' ? '' : 'NON-BANK-OWNED',
    COMMERCIAL:  isRecommendedProperties ? category : "COMMERCIAL",
    FORECLOSURE: fcOnlineFlag === 'Y' ? 'ONLINE FORECLOSURE' : 'FORECLOSURE',
    // ABS: 'BANK-OWNED',
    // CWCOT: 'CWCOT FIRST LOOK PROGRAM',
  };

  const dotColor = {
    REO: 'rgb(255, 121, 0)',
    SC: 'rgb(255, 121, 0)',
    NPL:'rgb(255, 121, 0)',
    SHRT_SALE: 'rgb(62, 149, 204)',
    NON_REO: 'rgb(255, 121, 0)',
    COMMERCIAL: 'rgb(255, 255, 255)',
    FORECLOSURE: 'rgb(143, 176, 53)',
    ABS: 'rgb(255, 121, 0)',
    CWCOT: 'rgb(255, 121, 0)',
  };
  const bgColor = {
    REO: 'rgba(0, 0, 0, 0.6)',
    SC: 'rgba(0, 0, 0, 0.6)',
    NPL: 'rgba(0, 0, 0, 0.6)',
    SHRT_SALE: 'rgba(0, 0, 0, 0.6)',
    NON_REO: 'rgba(0, 0, 0, 0.6)',
    COMMERCIAL: 'rgb(42, 105, 163)',
    FORECLOSURE: 'rgba(0, 0, 0, 0.6)',
    ABS: 'rgba(255, 255, 255, 1)',
    CWCOT: 'rgba(255, 255, 255, 1)',
  };
  return (
    <ul className="tag mb0 d-flex flex-wrap" style={{left: 5, zIndex: 1, bottom: 3, top: 'auto', gap: '0px'}}>
      {(newToHubzuFlag === 'Y' || isNewToHubzu === 'Y') && (
      <li className={`list-inline-item ${isRecommendedProperties ? 'new-tag-recommended' : 'new-tag-container'}`}>
        <a href="#" className={`text-capitalize ${isRecommendedProperties ? 'new-text-recommended' : 'new-tag-text'}`}>NEW</a>
      </li>)}
      {category && !!label[category] && (
        <li className="list-inline-item tag-text-container" style={{backgroundColor: bgColor[category] ? bgColor[category] : 'black'}}>
          <a href="#" className="text-capitalize tag-text">
            <div className="tag_dot" style={{ backgroundColor: dotColor[category] ? dotColor[category] : 'black'}} />{label[category]}
          </a>
        </li>
      )}
    </ul>
  );
};

export default memo(PropertyTags);
